var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("档口收包记录")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "城市",
                                      multiple: ""
                                    },
                                    on: { change: _vm.cityChange },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  _vm._l(_vm.resData.market_option, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.city_index,
                                      attrs: {
                                        label: item.city,
                                        value: item.city_index
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "市场" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "市场"
                                    },
                                    on: { change: _vm.marketChange },
                                    model: {
                                      value: _vm.form.market_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "market_id", $$v)
                                      },
                                      expression: "form.market_id"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: 0 }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.market, function(item) {
                                      return _c("el-option", {
                                        key: item.market_id,
                                        attrs: {
                                          label: item.market_name,
                                          value: item.market_id
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "包裹号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.package_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "package_no", $$v)
                                    },
                                    expression: "form.package_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "包裹状态"
                                    },
                                    model: {
                                      value: _vm.form.packge_status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "packge_status", $$v)
                                      },
                                      expression: "form.packge_status"
                                    }
                                  },
                                  _vm._l(_vm.ConstEnum.packageOptions, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "是否已点货"
                                    },
                                    model: {
                                      value: _vm.form.pici_is_da_biao,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "pici_is_da_biao",
                                          $$v
                                        )
                                      },
                                      expression: "form.pici_is_da_biao"
                                    }
                                  },
                                  _vm._l(_vm.is_da_biao, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      filterable: "",
                                      placeholder: "代采组"
                                    },
                                    model: {
                                      value: _vm.form.pgid,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pgid", $$v)
                                      },
                                      expression: "form.pgid"
                                    }
                                  },
                                  _vm._l(_vm.resData.pglist, function(item) {
                                    return _c("el-option", {
                                      key: item.pgid,
                                      attrs: {
                                        label: item.pgname,
                                        value: item.pgid
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      filterable: "",
                                      placeholder: "代采员"
                                    },
                                    model: {
                                      value: _vm.form.pgm_ids,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pgm_ids", $$v)
                                      },
                                      expression: "form.pgm_ids"
                                    }
                                  },
                                  _vm._l(_vm.resData.pg_member_option, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.label,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_name", $$v)
                                    },
                                    expression: "form.supply_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "批次单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.pici_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "pici_no", $$v)
                                    },
                                    expression: "form.pici_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "是否有差异"
                                    },
                                    model: {
                                      value: _vm.form.is_chayi,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_chayi", $$v)
                                      },
                                      expression: "form.is_chayi"
                                    }
                                  },
                                  _vm._l(_vm.is_chayi, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "异常处理人" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.yc_admin_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "yc_admin_name", $$v)
                                    },
                                    expression: "form.yc_admin_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "异常状态"
                                    },
                                    model: {
                                      value: _vm.form.yc_status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "yc_status", $$v)
                                      },
                                      expression: "form.yc_status"
                                    }
                                  },
                                  _vm._l(_vm.yc_status, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-cascader", {
                                  attrs: {
                                    placeholder: "包裹生成地点",
                                    options: _vm.resData.package_option,
                                    props: { multiple: true },
                                    filterable: ""
                                  },
                                  model: {
                                    value: _vm.form.receiving_site,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "receiving_site", $$v)
                                    },
                                    expression: "form.receiving_site"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "包裹类型"
                                    },
                                    model: {
                                      value: _vm.form.package_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "package_type", $$v)
                                      },
                                      expression: "form.package_type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "大货", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "备货", value: "2" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "前置仓", value: "3" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "版衣", value: "6" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "退换", value: "7" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "打标来源"
                                    },
                                    model: {
                                      value: _vm.form.db_source,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "db_source", $$v)
                                      },
                                      expression: "form.db_source"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "一手收包人员",
                                        value: "1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "档口送包人员",
                                        value: "2"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "快递送包", value: "3" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "接收仓库"
                                    },
                                    model: {
                                      value: _vm.form.stock_storehouse_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "stock_storehouse_id",
                                          $$v
                                        )
                                      },
                                      expression: "form.stock_storehouse_id"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "0", label: "全部" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.resData.stock_storehouse_option,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "是否质检任务" },
                                    model: {
                                      value: _vm.form.is_pre_qc,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_pre_qc", $$v)
                                      },
                                      expression: "form.is_pre_qc"
                                    }
                                  },
                                  _vm._l(_vm.ConstEnum.preQcOptions, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "车牌号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.licence_plate_no,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "licence_plate_no",
                                        $$v
                                      )
                                    },
                                    expression: "form.licence_plate_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "爆版发货单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.invoice_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "invoice_no", $$v)
                                    },
                                    expression: "form.invoice_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "快递运单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.shipping_num,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipping_num", $$v)
                                    },
                                    expression: "form.shipping_num"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "快递状态" },
                                    model: {
                                      value: _vm.form.shipping_status,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "shipping_status",
                                          $$v
                                        )
                                      },
                                      expression: "form.shipping_status"
                                    }
                                  },
                                  _vm._l(_vm.resData.shipping_status, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "包裹状态标签"
                                    },
                                    model: {
                                      value: _vm.form.package_status_label,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "package_status_label",
                                          $$v
                                        )
                                      },
                                      expression: "form.package_status_label"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "撤标", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "作废", value: "2" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      multiple: "",
                                      placeholder: "次品员"
                                    },
                                    model: {
                                      value: _vm.form.dg_member_ids,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "dg_member_ids", $$v)
                                      },
                                      expression: "form.dg_member_ids"
                                    }
                                  },
                                  _vm._l(
                                    _vm.resData.defective_member_options,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "包裹生成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.package_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "package_time", $$v)
                                    },
                                    expression: "form.package_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "收包结束时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.end_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "end_time", $$v)
                                    },
                                    expression: "form.end_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "仓库接收：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.storage_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "storage_time", $$v)
                                    },
                                    expression: "form.storage_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "提交点货：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.pici_commit_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "pici_commit_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.pici_commit_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "批次创建：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.pici_create_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "pici_create_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.pici_create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "包裹装车时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.loading_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "loading_time", $$v)
                                    },
                                    expression: "form.loading_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "快递签收：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.shipping_signing_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "shipping_signing_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.shipping_signing_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "50px",
                  padding: "0 25px",
                  "text-align": "right"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { background: "#85ce61" },
                    attrs: { type: "success", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.output(1)
                      }
                    }
                  },
                  [_vm._v("导出收包记录列表")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { background: "#85ce61" },
                    attrs: { type: "success", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.output(0)
                      }
                    }
                  },
                  [_vm._v("导出收包记录明细")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      { attrs: { data: _vm.resData.list } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_city",
                            label: "城市"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "market_name",
                            label: "市场"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "pgname",
                            label: "代采组"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "pg_member_name",
                            label: "代采员"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_name",
                            label: "商家"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "dg_member_name",
                            label: "次品员"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "包裹商品数" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row.is_unknown_package == 2
                                            ? "数量不明"
                                            : scope.row.goods_num
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2219447367
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "package_no",
                            label: "包裹号",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "buttonText",
                                        attrs: {
                                          href:
                                            "#/home/storage/tallying?package_no=" +
                                            scope.row.package_no,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.package_no))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            145679676
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "package_type",
                            label: "包裹类型",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "db_source",
                            label: "打标来源",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "package_status_text",
                            label: "包裹状态"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(scope.row.package_status_text)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { color: "#259ED6" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.package_status_label_text
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2591986685
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "invoice_no_text",
                            label: "爆版发货单"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_name",
                            label: "快递公司"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_num",
                            label: "快递运单号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_status_txt",
                            label: "快递最新状态",
                            width: "160"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    row.shipping_code
                                      ? [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.shipping_status_txt)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          row.shipping_status !== "99"
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "4px"
                                                  },
                                                  attrs: { size: "small" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleGetShippingDetail(
                                                        row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  物流详情\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3717774620
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_collection_time",
                            label: "快递揽收时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_signing_time",
                            label: "快递签收时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "pre_qc_text",
                            label: "是否质检"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    row.qc_task_id
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleNavQcDetail(
                                                  row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                是\n              "
                                            )
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(row.pre_qc_text))
                                        ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            136750028
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_package_record_receiving_site",
                            label: "包裹生成地点"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "create_time",
                            label: "包裹生成时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "end_time",
                            label: "收包结束时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "truck_loading_time",
                            label: "包裹装车时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "licence_plate_no",
                            label: "车牌号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "storage_admin",
                            label: "仓库接收人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "storehouse",
                            label: "接收仓库"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "has_wo",
                            label: "接收是否已核单"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "first_order_time",
                            label: "首次核单时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "storage_time",
                            label: "仓库接收时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "pici_create_time",
                            width: "180",
                            label: "批次创建时间"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _vm._l(
                                    scope.row.pici_create_time,
                                    function(create_time, create_time_key) {
                                      return _c(
                                        "span",
                                        {
                                          key: create_time_key,
                                          staticStyle: {
                                            width: "160px",
                                            margin: "0",
                                            cursor: "pointer"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(create_time)
                                          ),
                                          _c("br")
                                        ]
                                      )
                                    }
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            877709224
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pici_no",
                            label: "批次号",
                            width: "180",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _vm._l(scope.row.pici_no, function(
                                    pici_no_value,
                                    pici_no_key
                                  ) {
                                    return _c(
                                      "span",
                                      {
                                        key: pici_no_key,
                                        staticStyle: {
                                          width: "160px",
                                          margin: "0",
                                          cursor: "pointer"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(pici_no_value)
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  })
                                }
                              }
                            ],
                            null,
                            false,
                            2144682317
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "allot_workbench_time",
                            label: "包裹分配时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "workbench",
                            label: "分配工作台"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pici_goods_num",
                            label: "点货数量",
                            width: "180",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _vm._l(
                                    scope.row.pici_goods_num,
                                    function(
                                      pici_goods_num_value,
                                      pici_goods_num_key
                                    ) {
                                      return _c(
                                        "span",
                                        {
                                          key: pici_goods_num_key,
                                          staticStyle: {
                                            width: "160px",
                                            margin: "0",
                                            cursor: "pointer"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(pici_goods_num_value)
                                          ),
                                          _c("br")
                                        ]
                                      )
                                    }
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            3554658591
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "chayi_num",
                            label: "差异"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "admin_name",
                            label: "点货人",
                            width: "180",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _vm._l(scope.row.admin_name, function(
                                    admin_name_value,
                                    admin_name_key
                                  ) {
                                    return _c(
                                      "span",
                                      {
                                        key: admin_name_key,
                                        staticStyle: {
                                          width: "160px",
                                          margin: "0",
                                          cursor: "pointer"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(admin_name_value)
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  })
                                }
                              }
                            ],
                            null,
                            false,
                            178139581
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_sn",
                            label: "点货提交时间",
                            width: "180",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _vm._l(scope.row.commit_time, function(
                                    commit_time_value,
                                    commit_time_key
                                  ) {
                                    return _c(
                                      "span",
                                      {
                                        key: commit_time_key,
                                        staticStyle: {
                                          width: "160px",
                                          margin: "0",
                                          cursor: "pointer"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(commit_time_value)
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  })
                                }
                              }
                            ],
                            null,
                            false,
                            253767377
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "package_dabiao_status_txt",
                            label: "包裹点货状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "yc_admin_name",
                            label: "处理人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleClick(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("查看")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getLog(scope.row)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  扫描日志"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1200649612
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.form.page,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "扫描日志",
            visible: _vm.log.show,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.log, "show", $event)
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.log.list } },
            [
              _c("el-table-column", {
                attrs: { prop: "operator_name", label: "操作人" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "create_date", label: "操作时间" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.shippingMsgVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.shippingMsgVisible = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  color: "#e96b29",
                  "font-weight": "500",
                  "font-size": "18px"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.handleCopyText(_vm.shippingMsg.shipping_num)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          快递单号：" +
                        _vm._s(_vm.shippingMsg.shipping_num) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.shippingMsg.list } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "context", label: "操作" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "time",
                  width: "200",
                  label: "时间"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.shippingMsgVisible = false
                    }
                  }
                },
                [_vm._v("\n        确定\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-769b9259", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769b9259","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/SupplyPackageList.vue
// module id = null
// module chunks = 